/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "bf08cecad85efd80f3a0303c26592c94c9219486";
